import { crossesAntimeridian, trackLngPairs, footprintIsShifted } from './trackFrame.js';
import { hazardBounds } from './hazardBounds.js';

// Degrees around the storm's bounds within which a west-hemisphere pin is moved to the storm's side.
const MARGIN_DEG = 30;

/**
 * Bounds of a storm drawn in the shifted [0, 360) longitude frame (it crosses the date line), else null.
 * Same rule as the storm layer, so pins and storm agree on which side of the map they are drawn.
 */
export function shiftedStormBounds(parsed) {
  if (!parsed?.track) return null;
  const shifted = footprintIsShifted(parsed) || crossesAntimeridian(trackLngPairs(parsed.track));
  return shifted ? hazardBounds(parsed) : null;
}

/**
 * [lat, lng] at which to draw a region pin. With a shifted storm, a pin with a negative longitude that
 * sits near the storm once moved by +360 is drawn there; every other pin keeps its own coordinates.
 */
export function regionPinPosition(region, stormBounds) {
  const { latitude: lat, longitude: lng } = region;
  if (!stormBounds || !Number.isFinite(lat) || !Number.isFinite(lng) || lng >= 0) return [lat, lng];
  const [[minLat, minLng], [maxLat, maxLng]] = stormBounds;
  const moved = lng + 360;
  const near =
    moved >= minLng - MARGIN_DEG && moved <= maxLng + MARGIN_DEG &&
    lat >= minLat - MARGIN_DEG && lat <= maxLat + MARGIN_DEG;
  return near ? [lat, moved] : [lat, lng];
}
